import controller from "./__init/controller";
import detectTabNav from "./__utils/detectTabNav";
import throttle from "lodash/throttle";

let handled = false;

controller.init();

window.addEventListener("load", controller.loaded);
window.addEventListener("scroll", throttle(controller.scrolled, 100), {
  passive: true,
});
window.addEventListener("resize", throttle(controller.resized, 100));
window.addEventListener("keydown", (e) => {
  detectTabNav(e);
  controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
  if (e.type === "touchend") {
    handled = true;
    controller.mouseUp(e);
  } else if (e.type === "mouseup" && !handled) {
    controller.mouseUp(e);
  } else {
    handled = false;
  }
};

document.addEventListener("mouseup", handleMouseAndTouchEvents);
document.addEventListener("touchend", handleMouseAndTouchEvents);

// Archive page blog
const $ = jQuery.noConflict();
$(".raf-archive__category").on("click", function () {
  $(".raf-archive__category").removeClass("raf-archive__category--active");
  $(this).addClass("raf-archive__category--active");

  $(".raf-archive__categories").addClass("raf-archive__categories--loading");
  $(".raf-archive__wrapper").addClass("raf-archive__wrapper--loading");

  const termId = $(this).data("term-id");
  const currentPostType = $(".raf-archive__categories").data("post-type");
  const currentTaxonomy = $(".raf-archive__categories").data("taxonomy");

  let data = {
    action: "archive_posts_filter",
    termId,
    currentPostType,
    currentTaxonomy,
  };
  console.log(data);
  $.post(rfnl.ajaxurl, data)
    .done(function (response) {
      // console.log(response);
      $(".raf-archive__wrapper").html(response);
      $(".raf-archive__categories").removeClass(
        "raf-archive__categories--loading"
      );
      $(".raf-archive__wrapper").removeClass("raf-archive__wrapper--loading");
    })
    .fail(function (xhr, status, error) {
      console.log(xhr);
    });
});
